export const OpenIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
			<rect width="50" height="50" rx="15" fill="#262A2F" />
			<path d="M16 25H34" stroke="white" strokeWidth="2" />
			<path d="M25 16L25 34" stroke="white" strokeWidth="2" />
		</svg>
	)
}
